module.exports = __webpack_public_path__ + "img/img_thumb_0603.83eef64e.png";